import { useContext } from "react";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { MessageOutlined } from "@ant-design/icons";

interface IProps {
    text?: string;
    onClick: () => void;
}

export default function CardSuggestionMessage({ text, onClick }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    return (
        <button
            type="button"
            onClick={onClick}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                background: isDark ? "#1f1f1f" : "#f1f5f9",
                border: `1px solid ${isDark ? "#303030" : "#cbd5e1"}`,
                borderRadius: 16,
                padding: "4px 10px",
                fontSize: 11.5,
                fontWeight: 500,
                color: isDark ? "#d9d9d9" : "#334155",
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "all 0.2s ease",
                outline: "none",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = isDark ? "#112a45" : "#e6f4ff";
                e.currentTarget.style.borderColor = "#1677ff";
                e.currentTarget.style.color = isDark ? "#69b1ff" : "#0958d9";
                e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = isDark ? "#1f1f1f" : "#f1f5f9";
                e.currentTarget.style.borderColor = isDark ? "#303030" : "#cbd5e1";
                e.currentTarget.style.color = isDark ? "#d9d9d9" : "#334155";
                e.currentTarget.style.transform = "translateY(0)";
            }}
        >
            <MessageOutlined style={{ fontSize: 10, color: "#1677ff" }} />
            <span>{text}</span>
        </button>
    );
}